import React from "react";
import { Search, Filter } from "lucide-react";

import "./CustomerFilters.css";

const CustomerFilters = ({
  search,
  setSearch,
  levelFilter,
  setLevelFilter,
  statusFilter,
  setStatusFilter,
}) => {
  return (
    <div className="customer-filters">

      <div className="search-box">

        <Search size={18} />

        <input
          type="text"
          placeholder="Search by name or email..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />

      </div>

      <div className="filter-group">

        <div className="filter-item">

          <Filter size={16} />

          <select
            value={levelFilter}
            onChange={(e) =>
              setLevelFilter(e.target.value)
            }
          >
            <option value="All">All Levels</option>
            <option value="1">Level 1</option>
            <option value="2">Level 2</option>
            <option value="3">Level 3</option>
            <option value="4">Level 4</option>
          </select>

        </div>

        <div className="filter-item">

          <Filter size={16} />

          <select
            value={statusFilter}
            onChange={(e) =>
              setStatusFilter(e.target.value)
            }
          >
            <option value="All">All Status</option>
            <option value="Active">Active</option>
            <option value="Pending">Pending</option>
            <option value="Completed">Completed</option>
          </select>

        </div>

      </div>

    </div>
  );
};

export default CustomerFilters;